<template>
  <div
    class="relative rounded p-1 border border-gray-200 bg-gray-100 flex items-center"
  >
    <div
      class="z-10 absolute right-0 button px-2 py-1 ml-2 text-xs w-12 h-5 flex justify-center leading-none mr-1"
      :class="buttonCss"
      @click="copyText"
      v-tooltip="tooltipText"
    >
      <span
        v-text="buttonText"
        v-if="!error && !copied"
        class="whitespace-no-wrap"
      ></span>
      <span
        v-text="successText"
        v-if="!error && copied"
        class="whitespace-no-wrap"
      ></span>
      <span
        v-text="errorText"
        v-if="error && !copied"
        class="whitespace-no-wrap"
      ></span>
    </div>
    <div v-text="message" class="z-1 overflow-x-hidden text-xs"></div>
  </div>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {
      copied: false,
      error: false,
    };
  },
  methods: {
    copyText() {
      this.error = false;
      this.copied = false;
      this.$copyText(this.message).then(
        () => {
          this.copied = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.copied = false;
          }, 3000);
        },
        () => {
          this.error = true;
        }
      );
    },
  },
  computed: {
    buttonCss() {
      if (!this.error && !this.copied) {
        return "action-secondary border-action";
      }

      if (!this.error && this.copied) {
        return "bg-green-200 text-green-800 border border-green-800";
      }

      if (!this.error && this.copied) {
        return "bg-red-100";
      }
      return "";
    },
    buttonText() {
      let texts = {
        en: "Copy",
        fr: "Copier",
      };

      return texts[this.locale];
    },
    successText() {
      let texts = {
        en: "Copied!",
        fr: "Copié !",
      };

      return texts[this.locale];
    },
    errorText() {
      let texts = {
        en: "Error",
        fr: "Erreur",
      };

      return texts[this.locale];
    },
    tooltipText() {
      let texts = {
        en: "Copy to your clipboard",
        fr: "Copier dans votre presse-papier",
      };

      return texts[this.locale];
    },
    locale() {
      return this.$route.params.locale;
    },
  },
};
</script>
